export interface NotThirdPartyDataDTO {
    id: string
    fiscalCode: string
    region: string
    province: string
    city: string
    address: string
    contact: string
    phone: string
    odc: string
    activity: string
    dataSource: string
    addicted: string
    notificationId: string
}

export interface NotThirdPartyProcessingDataDTO {
    id: string
    productiveUnit: string
    cuaa: string
    production: string
    activity: string
    classification: string
    noPrinting: boolean
    notificationId: string
}

export interface NotThirdPartyProcessingCreateDTO {
    productiveUnit?: string
    cuaa?: string
    production?: string
    activity?: string
    classification?: string
    noPrinting?: boolean
    notificationId?: string
}

export enum filierraNotContoTerzi {
    PRODOTTI_DELL_APICOLTURA = 'PRODOTTI_DELL_APICOLTURA',
    CIBI_PRONTI_OMOGENEIZZATI_E_DIETETICI = 'CIBI_PRONTI_OMOGENEIZZATI_E_DIETETICI',
    BEVANDE_ESCLUSO_VINO = 'BEVANDE_ESCLUSO_VINO',
    LIEVITO = 'LIEVITO',
    UOVA = 'UOVA',
    VENDITA_AL_DETTAGLIO = 'VENDITA_AL_DETTAGLIO',
    FLOROVIVAISTICA = 'FLOROVIVAISTICA',
    CEREALICOLA = 'CEREALICOLA',
    ORTICOLA = 'ORTICOLA',
    VITIVINICOLA = 'VITIVINICOLA',
    MANGIMISTICA = 'MANGIMISTICA',
    OLIVICOLA = 'OLIVICOLA',
    FRUTTICOLA = 'FRUTTICOLA',
    CARNE_E_SALUMI = 'CARNE_E_SALUMI',
    PESCI_CROSTACEI_E_MOLLUSCHI = 'PESCI_CROSTACEI_E_MOLLUSCHI',
    GRASSI_VEGETALI_E_ANIMALI = 'GRASSI_VEGETALI_E_ANIMALI',
    LATTE_E_DERIVATI = 'LATTE_E_DERIVATI',
    MOLITURA_FORNO_E_FARINACEI = 'MOLITURA_FORNO_E_FARINACEI',
    ZUCCHERO = 'ZUCCHERO',
    CACAO = 'CACAO',
    TE = 'TE',
    CAFFE = 'CAFFE',
    CONDIMENTI_E_SPEZIE = 'CONDIMENTI_E_SPEZIE'
}

export enum ProcessingActivityEnum {
    CONFEZIONAMENTO = 'CONFEZIONAMENTO',
    TRASFORMAZIONE = 'TRASFORMAZIONE',
    MAGAZZINAGGIO = 'MAGAZZINAGGIO',
    FRIGOCONSERVAZIONE = 'FRIGOCONSERVAZIONE',
    ETICHETTATURA = 'ETICHETTATURA',
    COMMERCIALIZZAZIONE = 'COMMERCIALIZZAZIONE'
}

export enum ProcessingMethodType {
    BIOLOGICA = 'BIOLOGICA',
    PROMISCUO = 'PROMISCUO'
}

export interface NotThirdPartyStructureDataDTO {
    id: string
    productiveUnitNumber: string
    activity: string
    cadastralCode: string
    section: string
    sheet: string
    parcel: string
    sub: string
    address: string
    ownership: string
    usage: string
    area: number
    method: string
    notificationId: string
}

export interface NotThirdPartyResponseDTO {
    page: number
    total: number
    perPage: number
    prev: boolean
    next: boolean
    totalPage: number | null
    data: NotThirdPartyDataDTO[]
}

export interface NotThirdPartyProcessingResponseDTO {
    page: number
    total: number
    perPage: number
    prev: boolean
    next: boolean
    totalPage: number | null
    data: NotThirdPartyProcessingDataDTO[]
}

export interface NotThirdPartyStructureResponseDTO {
    page: number
    total: number
    perPage: number
    prev: boolean
    next: boolean
    totalPage: number | null
    data: NotThirdPartyStructureDataDTO[]
}



export interface filtersDTO {
    notificationId?: string
    page: number
    itemsPerPage: number
}

